const browserPrefixes = ['moz', 'ms', 'o', 'webkit'];
let isVisible = true; // internal flag, defaults to true

// get the correct attribute name
function getHiddenPropertyName(prefix: any) {
    return (prefix ? prefix + 'Hidden' : 'hidden');
}

// get the correct event name
function getVisibilityEvent(prefix: any) {
    return (prefix ? prefix : '') + 'visibilitychange';
}

// get current browser vendor prefix
function getBrowserPrefix() {
    for (const prefix of browserPrefixes) {
        if (getHiddenPropertyName(prefix) in document) {
            // return vendor prefix
            return prefix;
        }
    }

    // no vendor prefix needed
    return null;
}

// bind and handle events
const browserPrefix = getBrowserPrefix();
const hiddenPropertyName = getHiddenPropertyName(browserPrefix);
const visibilityEventName = getVisibilityEvent(browserPrefix);

function onVisible() {
    // prevent double execution
    if (isVisible) { return; }

    // change flag value
    isVisible = true;
    return isVisible;
}

function onHidden () {
    // prevent double execution
    if (!isVisible) { return; }

    // change flag value
    isVisible = false;
    return isVisible;
}

function handleVisibilityChange (forcedFlag: any, container?: any) {
    let visible: any;

    // forcedFlag is a boolean when this event handler is triggered by a
    // focus or blur eventotherwise it's an Event object
    if (typeof forcedFlag === "boolean") {
        if (forcedFlag) { visible = onVisible(); }
        else { visible = onHidden(); }
    } else if (document[hiddenPropertyName]) {
        visible = onHidden();
    } else {
        visible = onVisible();
    }

    if (visible !== undefined) {
        container.visible = visible;
    }
}

export const onVisibilityChange = (fn: Function, container: any) => {
    const func = (state?: boolean) => {
        handleVisibilityChange(state, container);
        fn(container.visible);
    };

    container.enabled = true;
    container.visible = true;

    const funcAny = () => func();
    const funcTrue = () => func(true);
    const funcFalse = () => func(false);

    document.addEventListener(visibilityEventName, funcAny, false);
    // extra event listeners for better behaviour
    document.addEventListener('focus', funcTrue, false);
    document.addEventListener('blur', funcFalse, false);
    window.addEventListener('focus', funcTrue, false);
    window.addEventListener('blur', funcFalse, false);

    container.disposer = () => {
        document.removeEventListener(visibilityEventName, funcAny, false);
        // extra event listeners for better behaviour
        document.removeEventListener('focus', funcTrue, false);
        document.removeEventListener('blur', funcFalse, false);
        window.removeEventListener('focus', funcTrue, false);
        window.removeEventListener('blur', funcFalse, false);
    }
};
